import { render, staticRenderFns } from "./LinkWizardPreReleaseFinal.vue?vue&type=template&id=539d1389&scoped=true&"
import script from "./LinkWizardPreReleaseFinal.vue?vue&type=script&lang=js&"
export * from "./LinkWizardPreReleaseFinal.vue?vue&type=script&lang=js&"
import style0 from "./LinkWizardPreReleaseFinal.vue?vue&type=style&index=0&id=539d1389&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d1389",
  null
  
)

export default component.exports